import { render, staticRenderFns } from "./MessageTemplatesCreateDialog.vue?vue&type=template&id=d8bca8d8&"
import script from "./MessageTemplatesCreateDialog.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports